import {Checkbox, RadioGroup, Radio, FormControl, FormLabel, FormControlLabel} from "@mui/material";
import React, {useEffect, useState} from "react";
import {makeStyles} from "@mui/styles";
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import globalVars from "../utils/globalVars";

const useStylesNormal = makeStyles({
        mycheckbox: {
            backgroundColor: 'transparent'
        }
    }
);

const useStylesFeedback = makeStyles({
        mycheckbox: {
            backgroundColor: ok => ok ? globalVars.feedbackMode.backgroundColor.ok : globalVars.feedbackMode.backgroundColor.notOk,
            // borderWidth: "1px",
            // borderStyle: "solid",
            // borderColor: ok => ok ? '#3ff' : '#f3f',
        }
    }
);

export default function CheckboxSubcomponent(props) {

    const [expectedChecked, setExpectedChecked] = useState(props.expectedChecked);
    const [currentChecked, setCurrentChecked] = useState(false);
    const [ok, setOk] = useState(false)
    const mode = 'mode_feedback'

    // const classes = useStyles(ok);
    const classesModeNormal = useStylesNormal();
    const classesModeFeeback = useStylesFeedback(expectedChecked == currentChecked);
    const classes = {
        'mode_normal': classesModeNormal,
        'mode_feedback': classesModeFeeback,
    }

    function handleChange(e) {
        setCurrentChecked(e.target.checked)
    }

    return (
        <Checkbox defaultChecked={false}
                  disableRipple={true}
                  className={classes[props.feedbackMode].mycheckbox}
                  onChange={handleChange}
                  title={props.expectedChecked ? 'checked' : 'unchecked'}
        >
        </Checkbox>
    )
}